import React, { useState, useContext } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import SuccessIcon from "../../../styles/img/svg/SuccessIcon";
import WarningIcon from "../../../styles/img/svg/WarningIcon";
import ErrorIcon from "../../../styles/img/svg/ErrorIcon";
import { hideError } from "../../../_redux/_actions";
import { isUserLoggin } from "../../../_helpers/auth.helper";
import { Context } from "../../../_context/Store";
import { contextApiActions } from "../../../_redux/_constants";

export default function UiErrorAlertBox(props) {
    const actionDispatch = useDispatch();
    const [state, dispatch] = useContext(Context);

    const navigate = useNavigate();

    const { errorMessage } = useSelector((state) => {
        return {
            errorMessage: state.errorMessage,
        };
    });

    const [show, setShow] = useState(true);
    const handleClose = () => setShow(false);

    const hideAlert = () => {
        if (errorMessage.statusCodes.includes("401")) {
            navigate("/");
            dispatch({
                type: contextApiActions.SET_REQUESTED_URL,
                payload: "/app/home",
            });
        }
        actionDispatch(hideError());
    };

    return (
        <>
            <Modal
                show={errorMessage.show}
                onHide={hideAlert}
                className="sb-alert-modal"
            >
                <Modal.Header closeButton> </Modal.Header>
                <Modal.Body>
                    {props.success && <SuccessIcon />}
                    {props.warning && <WarningIcon />}
                    {true && <ErrorIcon />}
                    <h3>{errorMessage.messages[0]}</h3>
                </Modal.Body>
            </Modal>
        </>
    );
}
